'use client';

import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';

const heroImages = [
  {
    src: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600&q=80',
    alt: 'Luxury resort pool with palm trees and ocean view at sunset',
  },
  {
    src: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1600&q=80',
    alt: 'Elegant villa with infinity pool overlooking tropical landscape',
  },
  {
    src: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1600&q=80',
    alt: 'Cozy mountain lodge with wooden interiors and fireplace',
  },
];

export default function HeroSection() {
  const [currentImage] = useState(0);

  return (
    <section className="relative w-full h-[520px] md:h-[600px] overflow-hidden">
      {/* Background image */}
      <AppImage
        src={heroImages?.[currentImage]?.src}
        alt={heroImages?.[currentImage]?.alt}
        fill
        className="object-cover object-center"
        priority
      />
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-black/40" />
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 pt-20 pb-10">
        <h1 className="text-3xl md:text-5xl font-bold text-white text-center mb-3 drop-shadow-lg">
          Find a place you'll love to stay
        </h1>
        <p className="text-white/90 text-base md:text-lg text-center mb-8 drop-shadow">
          Discover unique accommodations across Africa and beyond
        </p>

        {/* Search widget */}
        <div className="w-full max-w-3xl bg-white rounded-2xl shadow-2xl p-2 md:p-3">
          <div className="flex flex-col md:flex-row gap-2">
            {/* Destination */}
            <div className="flex-1 px-4 py-3 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer border border-transparent hover:border-gray-200">
              <div className="text-xs font-bold text-gray-800 mb-1">Where</div>
              <input
                type="text"
                placeholder="Search destinations"
                className="w-full text-sm text-gray-600 bg-transparent outline-none placeholder-gray-400"
              />
            </div>
            <div className="hidden md:block w-px bg-gray-200 self-stretch my-2" />
            {/* Check in */}
            <div className="flex-1 px-4 py-3 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer border border-transparent hover:border-gray-200">
              <div className="text-xs font-bold text-gray-800 mb-1">Check in</div>
              <input
                type="date"
                className="w-full text-sm text-gray-600 bg-transparent outline-none cursor-pointer"
              />
            </div>
            <div className="hidden md:block w-px bg-gray-200 self-stretch my-2" />
            {/* Check out */}
            <div className="flex-1 px-4 py-3 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer border border-transparent hover:border-gray-200">
              <div className="text-xs font-bold text-gray-800 mb-1">Check out</div>
              <input
                type="date"
                className="w-full text-sm text-gray-600 bg-transparent outline-none cursor-pointer"
              />
            </div>
            <div className="hidden md:block w-px bg-gray-200 self-stretch my-2" />
            {/* Guests */}
            <div className="flex-1 px-4 py-3 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer border border-transparent hover:border-gray-200">
              <div className="text-xs font-bold text-gray-800 mb-1">Who</div>
              <div className="text-sm text-gray-400">Add guests</div>
            </div>
            {/* Search button */}
            <button className="bg-[#4088C6] hover:bg-[#2D6FA8] text-white font-semibold px-6 py-3 rounded-xl transition-colors flex items-center gap-2 flex-shrink-0 self-stretch">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <span className="hidden md:inline">Search</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}